import createCachedSelector from 're-reselect';
import get from 'lodash.get';

import { emptyArray, emptyObject } from '../../../default-props/empty';

export const selectFulfillments = (state) => get(state, 'fulfillments', emptyObject);
export const selectFulfillmentById = (state, props) => get(selectFulfillments(state, props), props.fulfillmentId);

export const selectFulfillmentsByIds = createCachedSelector(
  selectFulfillments,
  (_, { fulfillmentIds }) => JSON.stringify(fulfillmentIds),
  (fulfillments, fulfillmentIdsJSON) => {
    const fulfillmentIds = JSON.parse(fulfillmentIdsJSON);

    if (fulfillmentIds.length === 0) {
      return emptyArray;
    }

    return fulfillmentIds.map((fulfillmentId) => fulfillments[fulfillmentId]);
  },
)((_, { fulfillmentIds }) => JSON.stringify(fulfillmentIds));

export const selectFulfillmentsByFulfillmentPlanId = createCachedSelector(
  selectFulfillments,
  (_, { fulfillmentPlanId }) => fulfillmentPlanId,
  (fulfillments, fulfillmentPlanId) => {
    if (!fulfillmentPlanId) {
      return emptyArray;
    }

    const fulfillmentsForFulfillmentPlan = Object.values(fulfillments).filter(
      (fulfillment) => fulfillment.fulfillmentPlanId === fulfillmentPlanId,
    );

    // reselect docs recommend returning a static empty array if there are no results
    return fulfillmentsForFulfillmentPlan.length ? fulfillmentsForFulfillmentPlan : emptyArray;
  },
)((_, { fulfillmentPlanId }) => fulfillmentPlanId || '');

export const selectFulfillmentsByFulfillmentPlanIds = createCachedSelector(
  selectFulfillments,
  (_, { fulfillmentPlanIds }) => JSON.stringify(fulfillmentPlanIds),
  (fulfillments, fulfillmentPlanIdsJSON) => {
    const fulfillmentPlanIds = JSON.parse(fulfillmentPlanIdsJSON);
    if (!fulfillmentPlanIds.length) {
      return emptyArray;
    }

    return Object.values(fulfillments).filter((fulfillment) => fulfillmentPlanIds.includes(fulfillment.fulfillmentPlanId));
  },
)((_, { fulfillmentPlanIds }) => JSON.stringify(fulfillmentPlanIds));

export const selectFPIdsByFulfillmentIds = (state, props) => {
  if (!props.fulfillmentIds) {
    return emptyArray;
  }
  const fulfillments = selectFulfillmentsByIds(state, props) || emptyArray;
  const fpids = fulfillments.map((fill) => fill?.fulfillmentPlanId).filter((fpid) => !!fpid);
  const fpidSet = new Set(fpids);
  return [...fpidSet];
};
